import { Layout, Text, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { ApiErrorModalContentViewProps } from './ApiErrorModalContentViewProps';
import { isServiceUnavailable } from '../../async/api-client';

const StyledText = styled(Text)`
  margin-bottom: ${(props) => props.theme.size.static350};
`;

export function ApiErrorModalContentVwView({ error }: ApiErrorModalContentViewProps): ReactElement {
  const serviceUnavailable = isServiceUnavailable(error);

  return (
    <Layout>
      <StyledText appearance={TokenTextAppearance.headline400} bold>
        {serviceUnavailable ? 'Service unavailable' : 'Sorry'}
      </StyledText>
      <Text>
        {serviceUnavailable
          ? 'The booking service is not responding right now. Please check your internet connection and try again later.'
          : 'An unknown error has occurred. Sorry for any inconvenience this may cause.'}
      </Text>
    </Layout>
  );
}
